/**
 * Icon Svg Calculator Component.
 */
export default class IconSizeCalculator {
	/**
	 * Calculate the actual size of the icon (in pixels).
	 *
	 * @param svgCode Code of the SVG.
	 * @param baseSize ...
	 * @returns Measurements object containing width and height.
	 */
	public static getMeasuredSize(
		svgCode: string,
		baseSize: number
	): { height: number; width: number } {
		if (!svgCode) {
			return {
				width: 0,
				height: 0
			};
		}
		const viewboxSize = this.getSvgViewbox(svgCode);
		if (viewboxSize.width > baseSize || viewboxSize.height > baseSize) {
			if (viewboxSize.width > viewboxSize.height) {
				return {
					width: baseSize,
					height: baseSize * (viewboxSize.height / viewboxSize.width)
				};
			} else {
				return {
					width: baseSize * (viewboxSize.width / viewboxSize.height),
					height: baseSize
				};
			}
		}
		return {
			width: (baseSize * viewboxSize.width) / baseSize,
			height: (baseSize * viewboxSize.height) / baseSize
		};
	}

	/**
	 * Rounds the value uppwards nearest number of decimals.
	 *
	 * @param value Value to round.
	 * @param numberOfDecimals Number of decimals.
	 * @returns The value rounded uppwards to closest number of decimals.
	 */
	public static round(value: number, numberOfDecimals = 2): number {
		const factor = 10 ** numberOfDecimals;
		return Math.round(value * factor) / factor;
	}

	/**
	 * @param svgCode Code of the SVG.
	 * @returns Viewbox of the svg code.
	 */
	private static getSvgViewbox(svgCode: string): { height: number; width: number } {
		const htmlElement = document.createElement('div');

		htmlElement.innerHTML = svgCode;

		const svgElement = htmlElement.querySelector('svg');

		if (!svgElement) {
			throw new Error(`Failed to parse SVG. Invalid SVG code: ${svgCode}`);
		}
		return {
			width: svgElement.viewBox.baseVal.width,
			height: svgElement.viewBox.baseVal.height
		};
	}
}
